package io.horion.cv.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleQuestion
import com.varabyte.kobweb.silk.components.icons.fa.FaEllipsisVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelopeOpenText
import com.varabyte.kobweb.silk.components.icons.fa.FaFileLines
import com.varabyte.kobweb.silk.components.icons.fa.FaHouse
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.UBUNTU
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Composable
fun AppSidebar(
    activeLabel: String = "Tableau de bord",
    onNav: (String) -> Unit,
    onLogout: () -> Unit = {}
) {
 /*   val navItems = listOf(
        Triple("Tableau de bord",       "/dashboard/tableau-de-bord",  "/home2.svg"),
        Triple("Curriculum vitae",      "/dashboard/cv",      "/letter-cv-icon.svg"),
        Triple("Lettres de motivation", "/dashboard/Lettres",       "/letter-icon.svg"),
        //Triple("Offres d'emplois",      "/dashboard/emploi",              "/briefcase-icon.svg"),
        //Triple("Candidatures",          "/dashboard/candidatures",     "/candidatures-icon.svg"),
    )
*/
    val navItems: List<Triple<String, String, @Composable (Modifier) -> Unit>> = listOf(
        Triple("Tableau de bord", "/dashboard/tableau-de-bord") { modifier: Modifier ->
            FaHouse(modifier = modifier)
        },
        Triple("Curriculum vitae", "/dashboard/cv") { modifier: Modifier ->
            FaFileLines(modifier = modifier)
        },
        Triple("Lettres de motivation", "/dashboard/Lettres") { modifier: Modifier ->
            FaEnvelopeOpenText(modifier = modifier)
        },
    )
    Column(
        modifier = Modifier
            .width(350.px)
            .height(100.vh)
            .backgroundColor(Colors.DarkBlue)
            .padding(top = 0.px, bottom = 30.px, leftRight = 0.px)
            .position(Position.Sticky)
            .top(0.px)
            .overflow(Overflow.Auto)
    ) {

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(leftRight = 20.px, top = 20.px, bottom = 60.px)
                .gap(10.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Row(
                modifier = Modifier.gap(10.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(
                    src = "/logo-CV-new-blanc.png",
                    description = "Logo ORION",
                    modifier = Modifier
                        .height(32.px)
                        .width(auto)
                )

                SpanText(
                    text = "CV",
                    modifier = Modifier
                        .fontSize(18.px)
                        .fontFamily(UBUNTU)
                        .fontWeight(FontWeight.Bold)
                        .color(Colors.White)
                )
            }
           /* Image(
                src = "/help-circle.svg",
                description = "Aide",
                modifier = Modifier.size(25.px).cursor(Cursor.Pointer)
            )*/
            FaCircleQuestion(
                modifier = Modifier.fontSize(25.px).cursor(Cursor.Pointer)
                    .color(Colors.White)
                    ,
                size = IconSize.LG
            )

        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .padding(leftRight = 16.px, bottom = 20.px)
        ) {
            NewItemDropdown(
                onNavigate = { path -> onNav(path) }
            )
        }

        navItems.forEach { (label, path, icon) ->
            val isActive = label == activeLabel
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(48.px)
                    .backgroundColor(if (isActive) Colors.HalfBlack else Colors.DarkBlue)
                    .cursor(Cursor.Pointer)
                    .onClick { onNav(path) },
                verticalAlignment = Alignment.CenterVertically
            ) {

                Box(
                    modifier = Modifier
                        .width(3.px)
                        .height(48.px)
                        .backgroundColor(if (isActive) Colors.lightblue else Colors.NightBlue)
                )
                Box(
                    modifier = Modifier.width(16.px)
                )
               /* Image(
                    src = icon,
                    description = label,
                    modifier = Modifier.size(18.px)
                )*/
                icon(
                    Modifier
                        .fontSize(18.px)
                        .color(if (isActive) Colors.White else Colors.DarkGray)
                )
                Box(
                    modifier = Modifier.width(15.px)
                )
                SpanText(
                    text = label,
                    modifier = Modifier
                        .fontFamily(INTER)
                        .fontSize(16.px)
                        .fontWeight(if (isActive) FontWeight.SemiBold else FontWeight.Normal)
                        .color(if (isActive) Colors.White else Colors.DarkGray)
                )
            }
        }

        Spacer()

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(leftRight = 20.px, top = 32.px)
                .gap(10.px)
                .cursor(Cursor.Pointer)
                .onClick { onLogout() },
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                contentAlignment = Alignment.Center,
                modifier = Modifier
                    .size(24.px)
                    .borderRadius(50.percent)
                    .border(2.px, LineStyle.Solid, Colors.White)
            ) {
                FaArrowLeft(
                    modifier = Modifier
                        .fontSize(12.px)
                        .color(Colors.White)
                )
            }
            SpanText(
                text = "Deconnexion",
                modifier = Modifier
                    .fontFamily(INTER)
                    .fontSize(16.px)
                    .color(Colors.DarkGray)
            )
        }
    }
}